import { MapPin } from "lucide-react";
import { useT } from "@/i18n/LanguageProvider";

export const Location = () => {
    const t = useT();
    const NEARBY = [
        { label: t({ de: "Rhein", en: "Rhine river" }), distance: t({ de: "wenige Minuten", en: "minutes away" }) },
        { label: t({ de: "Biebricher Schloss", en: "Biebrich Palace" }), distance: t({ de: "in der Nähe", en: "nearby" }) },
        { label: "Mainz", distance: t({ de: "schnell erreichbar", en: "easily reached" }) },
        { label: "Frankfurt", distance: t({ de: "Pendlerdistanz", en: "commutable" }) },
        { label: t({ de: "Rhein-Main-Flughafen", en: "Frankfurt airport" }), distance: t({ de: "ca. 20 Min", en: "approx. 20 min" }) },
        { label: t({ de: "Schulen & Kitas", en: "Schools & nurseries" }), distance: t({ de: "fußläufig", en: "walking distance" }) },
        { label: t({ de: "Einkaufen & Restaurants", en: "Shops & restaurants" }), distance: t({ de: "im Quartier", en: "in the neighbourhood" }) },
    ];

    const address = "Gaugasse 21, 65203 Wiesbaden";
    const mapsQuery = encodeURIComponent(address);
    const embedSrc = `https://www.google.com/maps?q=${mapsQuery}&output=embed&z=15`;
    const externalSrc = `https://www.google.com/maps/search/?api=1&query=${mapsQuery}`;

    return (
        <section id="lage" className="bg-cream py-24 sm:py-32" data-testid="location-section">
            <div className="container-page">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    <div className="lg:col-span-5 order-2 lg:order-1">
                        <span className="overline">{t({ de: "09 / 12 — Wiesbaden-Biebrich", en: "09 / 12 — Wiesbaden-Biebrich" })}</span>
                        <h2 className="h-section mt-4 text-balance">
                            {t({ de: "Eine der gefragtesten", en: "One of the most sought-after" })}
                            <span className="italic text-brand-500"> {t({ de: "Wohnlagen", en: "residential locations" })}</span> {t({ de: "Wiesbadens.", en: "in Wiesbaden." })}
                        </h2>
                        <p className="body-md mt-6">
                            {t({
                                de: "Die Nähe zum Rhein, das Biebricher Schloss sowie eine sehr gute Infrastruktur machen den Standort besonders attraktiv. Einkaufs­möglich­keiten, Restaurants, Schulen und Kindergärten befinden sich in unmittelbarer Umgebung. Mainz, Frankfurt und der Rhein-Main-Flughafen sind schnell erreichbar.",
                                en: "Proximity to the Rhine, Biebrich Palace and excellent infrastructure make this location especially attractive. Shops, restaurants, schools and nurseries are right around the corner. Mainz, Frankfurt and Frankfurt airport are easily reached.",
                            })}
                        </p>

                        <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3">
                            {NEARBY.map((n) => (
                                <div key={n.label} className="border-b border-stone-200 pb-2">
                                    <div className="font-body text-sm text-ink font-medium">{n.label}</div>
                                    <div className="font-body text-xs text-stone-500">{n.distance}</div>
                                </div>
                            ))}
                        </div>

                        <a
                            href={externalSrc}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-secondary mt-10"
                            data-testid="open-maps"
                        >
                            <MapPin size={16} />
                            In Google Maps öffnen
                        </a>
                    </div>

                    <div className="lg:col-span-7 order-1 lg:order-2">
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 frame-img aspect-[4/3] lg:aspect-[16/10] bg-stone-200 overflow-hidden">
                                <iframe
                                    src={embedSrc}
                                    title="Karte – Gaugasse 21, Wiesbaden"
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    className="w-full h-full border-0"
                                    data-testid="location-map-embed"
                                />
                            </div>
                            <div className="col-span-12 bg-ink text-white p-6 lg:p-8">
                                <div className="flex items-start gap-4">
                                    <MapPin size={22} className="text-clay-300 shrink-0 mt-1" />
                                    <div>
                                        <div className="overline text-clay-300">Adresse</div>
                                        <div className="font-heading text-2xl mt-1">
                                            {address}
                                        </div>
                                        <div className="font-body text-sm text-white/70 mt-2">
                                            Wiesbaden-Biebrich · Rheinblick & Schlossnähe
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
